var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"h3 container-title"},[_vm._v(_vm._s(_vm.pageName))])}
var staticRenderFns = []

export { render, staticRenderFns }